import { createReducer, on } from "@ngrx/store";
import { navigationModel } from "@sports-models/index";
import * as SportsbookActions from "../sportsbook.actions";

export const initialState: navigationModel = {
  prevUrl: null,
  currentUrl: null,
  history: [],
};

export const SportsbookNavigationReducer = createReducer(
  initialState,
  // Navigation
  on(SportsbookActions.navigationUpdate, (state, { type, ...payload }) => {
    const history = payload.history.slice(0, 30);
    return {
      ...state,
      ...payload,
      history,
    };
  }),
  on(SportsbookActions.historyUpdate, (state, { type, ...payload }) => {
    const history = payload.history.slice(0, 30);
    return {
      ...state,
      ...payload,
      history,
    };
  }),
);
